import {
  PROJECTS_ADMIN_CRUD_MODAL,
  PROJECTS_ADMIN_SET_USER_LIST,
  PROJECTS_ADMIN_SET_PROJECTS_LIST,
  PROJECTS_ADMIN_SELECTED_USER,
  PROJECTS_ADMIN_IS_LOADING, PROJECTS_ADMIN_MULTIBED_WARNING,
  // PROJECTS_ADMIN_LOADED_OTHER_U_PROJECT
} from "../lib/types";

export const toggleProjectsAdminModal = toggle => dispatch => {
  dispatch({
    type: PROJECTS_ADMIN_CRUD_MODAL,
    payload: toggle,
  });
};

export const showProjectsAdminMultibedWarning = toggle => dispatch => {
  dispatch({
    type: PROJECTS_ADMIN_MULTIBED_WARNING,
    payload: toggle,
  });
};

export const setProjectsAdminUserList = users => dispach => {
  dispach({
    type: PROJECTS_ADMIN_SET_USER_LIST,
    payload: users,
  });
};

export const setProjectsAdminProjects = ( projects, iTokens ) => dispatch => {
  dispatch({
    type: PROJECTS_ADMIN_SET_PROJECTS_LIST,
    payload: {
      projects,
      iTokens
    }
  })
}

export const setAdminSelectedUser = selectedUser => dispatch => {
  dispatch({
    type: PROJECTS_ADMIN_SELECTED_USER,
    payload: selectedUser
  })
}

export const toggleAdminProjectsLoader = toggle => dispatch => {
  dispatch({
    type: PROJECTS_ADMIN_IS_LOADING,
    payload: toggle
  })
}



// WEBPACK FOOTER //
// ./src/actions/projects-admin-action.js